import { Observable } from 'rxjs';
import { ExtrasInterface } from '../models/extras.model';

export abstract class ExtrasRepository {
    abstract getExtras(
        id: number,
        coupon?: string,
        category?: string,
        pickupDate?: string,
        returnDate?: string,
    ): Observable<ExtrasInterface>;
}
